require('./globals.js');
require('./utils.js');
require('./debug.js');
require('../../node_modules/hammerjs/hammer.min.js');
require('./pixi-spine.js');
require('./pixi-filters.js');
require('./loader.js');
require('./stateMachine.js');
require('./game.js');
require('./soundManager.js');
require('./spinFunctions.js');
require('./cascadeInfiniReels.js');
require('./DUwinlineAnimationController.js');
require('./gameController.js');
require('./gigablox/reelSpinnerVisualGigablox.js');
require('./gigablox/gigabloxFactory.js');
require('./particleManager.js');
require('./screenShaker.js');
require('./freespins.js');
require('./freespinSpinButton.js');
require('./freespinSkipButton.js');
require('./freeSpinsIntro.js');
require('./freeSpinsOutro.js');
require('./maxWinPopup.js');
require('./paytablePopup.js');
require('./helper.js');
require('./scrollContainer.js');
require('./logo.js');
require('../../libs/reflex-library/src/lib/screenDimObject.js');
require('../../libs/reflex-library/src/lib/screenshotAnimator.js');
require('./movieSymbolAnimatorDU.js');
require('./symbolWinBorderAnim.js');
require('./winlineFadeAnimator.js');
require('./musicManager.js');
require('./showReel.js');
require('./DUslamStopButton.js');
require('./excitementManager.js');
require('./bigWinController.js');
require('./fiveOAK.js');
require('../../libs/reflex-library/src/lib/colourBox.js');
require('../../libs/reflex-library/src/lib/spine.js');
require('../../libs/reflex-library/src/lib/shape.js');
require('./multiplierDisplay.js');
require('./pawModifier.js');
require('./gigaBloxIntroAnim.js');
require('./champagneModifier.js');
require('./goldenClawModifier.js');
require('./splashScreen.js');
require('./luckyBetToggle.js');

require('./freespinsMeter.js');
require('./symbolGlowManager.js');
require('./messagePopper.js');
require('./stakeMinusButton.js');
require('./stakePlusButton.js');
require('./messageBox.js');

require('./winlineBatcherLowWin.js');
require('./winningsText.js');
require('./buyBonusButton.js');
require('./buyBonusPopup.js');
require('./DUskipWinsButton.js');

require('./settingsMenu.js');
require('./settingsMenuButton.js');
require('./settingsMenuButtonClose.js');
require('./settingSound.js');

//Setting Menu Buttons
require('./systemSettingVolumeButton.js');
require('./systemSettings/systemSettingsButton.js');
require('./systemSettings/systemSettingsClose.js');
require('./systemSettings/systemSettingsIntroScreen.js');
require('./systemSettings/systemSettingsSounds.js');
require('./systemSettings/systemTotalBet.js');
require('./systemSettings/systemSettingsBox.js');

//Stake/Bet Menu
require('./stakeSettings/BPstakeSelectionPopup_ext.js');
//Autoplay
require('./autoplaySettings/BPautoplayManager-ext.js');

//Menubar
require('./sideMenu/sideMenuClose.js');
require('./sideMenu/sideMenuHelp.js');

require('./dublinRecoveryController.js');

require('../../libs/reflex-library/src/lib/gsap.min.js');
require('../../libs/reflex-library/src/lib/gsapPixiPlugin.js');
